export default __webpack_public_path__ + "static/media/3002.6065ab27.jpg";